import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const OtherAkcii = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){
        if($(this.$el).find('.js-promo-more-slider').length){
            let mpSwiperPromoMore = new Swiper('.js-promo-more-slider', {
                loop: true,
                lazyPreloadPrevNext: 2, // соседи видимых: Swiper снимает loading у их картинок — сигнал модулю lazyload.js
                grabCursor: true,
                slidesPerView: 4,
                spaceBetween: 30,
                autoplay: {
                delay: 3000
                },
                navigation: {
                nextEl: ".js-promo-more-next",
                prevEl: ".js-promo-more-prev"
                },
                breakpoints: {
                320: {
                    slidesPerView: 1.23,
                    spaceBetween: 8
                },
                440: {
                    slidesPerView: 2.4,
                    spaceBetween: 8
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
                }
            });
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section promo__mp">
    <div class="container">
        <div class="section__heading-wp">
            <div class="section__heading">
                <div class="section__title-wp">
                    <h2 class="section__title">
                        Другие акции
                    </h2>
                    <div class="section__nav-arrows">
                        <div class="swiper-button-prev slider-btn js-promo-more-prev">
                            <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        </div>
                        <div class="swiper-button-next slider-btn js-promo-more-next">
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper promo__slider js-promo-more-slider">
            <div class="swiper-wrapper">

                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="swiper-slide">
                    <div class="promo__item">
                        <a :href="item.LINK" class="promo__item-img" :class="{'no-photo': item.PICTURE === false}">
                            <img v-if="item.PICTURE !== false" class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME" loading="lazy">
                            <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                        </a>
                        <div class="promo__item-info">
                            <div class="promo__item-info-top">
                                <div v-if="item.DATE !== false" class="promo__item-info-leftside">
                                    <span>действует до:</span>
                                    <div class="promo__item-info-date">
                                        <span>{{item.DATE.day}}</span>
                                        {{item.DATE.month}}
                                    </div>
                                </div>
                                <div v-if="item.DATE !== false" class="promo__item-info-year">‘{{item.DATE.year}}</div>
                            </div>
                            <a :href="item.LINK" class="promo__item-desc">
                                {{item.NAME}}
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
    `
}